import $ from 'jquery';

const Categories = () => {
    console.log('Categories::');
    const pathname = window.location.pathname;
    const match = pathname.match(/\/category\/(.*?)\//);

    if (match && match[1]) {
        const category = match[1];
        console.log('Category::is::', category);
        $('.search-cat a').removeClass('active');
        $(`.search-cat .${category}`).addClass('active');
        setTimeout(()=>{
            document.getElementById('search-cat-nav').scrollIntoView({ behavior: "smooth" });
        }, 100);
    } else {
        console.log("No Category match found.");
    }
}

export default Categories;
